import React from 'react'

const Store = () => {
  return (
    <div>Store페이지</div>
  )
}

export default Store